import { MenuItem } from "./menu.model";

export const MENU: MenuItem[] = [
  {
    id: 1,
    label: "MENUITEMS.DASHBOARDS",
    isTitle: true,
  },
  {
    id: 2,
    label: "MENUITEMS.SERVICE.ORDERS",
    icon: "fas fa-chart-pie",
    link: "/dashboard/service-orders",
  },
  {
    id: 3,
    label: "MENUITEMS.PERFORMANCE",
    icon: "fas fa-chart-area",
    link: "/dashboard/performance",
  },
  {
    id: 4,
    label: "MENUITEMS.STOCK.CONTROL",
    icon: "fas fa-boxes",
    link: "/dashboard/stock-control",
  },
  // {
  //     id: 4,
  //     label: 'Comparativo',
  //     icon: 'fas fa-chart-bar',
  //     link: '/calendar',
  // },
  // {
  //     id: 4,
  //     label: 'Prestadores',
  //     icon: 'fas fa-users',
  //     link: '/calendar',
  // },
];
